// removed by extract-text-webpack-plugin
module.exports = {"Placeholder":"Placeholder__Placeholder__3OgWh","Visible":"Placeholder__Visible__K4voB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Placeholder/Placeholder.css
// module id = 363
// module chunks = 0